export default {
    flags: [],
    flag: {}
  }